import { bindActionCreators, compose } from "redux";
import { connect } from "react-redux";
import { siteActions } from "../../redux/actions/siteActions";
import { countryCityActions } from "../../redux/actions/countryCityActions";
import { withRouter } from "react-router";
import ManageSite from "./ManageSite";

const mapStateToProps = state => {
  return {
    sitedata: state.siteReducer.sitedata,
    messageResponse: state.siteReducer.messageResponse,
    emailResponse: state.siteReducer.emailResponse,
    siteDataById: state.siteReducer.siteDataById,
    siteEditResponse: state.siteReducer.siteEditResponse,
    siteResponse: state.siteReducer.siteResponse,
    error: state.siteReducer.error,
    sitenameResponse: state.siteReducer.sitenameResponse,
    sitedomainResponse: state.siteReducer.sitedomainResponse,
    citygeolocation: state.siteReducer.citygeolocation
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(
      {
        ...siteActions
      },
      dispatch
    )
  };
};

export default compose(
  withRouter, // IMPORTANT: witRouter is "needed here" to avoid blocking routing:
  connect(mapStateToProps, mapDispatchToProps)
)(ManageSite);



// WEBPACK FOOTER //
// ./src/app/views/manageSite/index.js